<template>
  <div></div>
</template>

<script>
export default {
  name: "AuthSetting"
}
</script>

<style scoped>

</style>